import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
const en = require('./translations/en.json');
const hi = require('./translations/hi.json');
const ar = require('./translations/ar.json');
const ba = require('./translations/ba.json');
const fr = require('./translations/fr.json');
const pt = require('./translations/pt.json');
const en_MY = require('./translations/en-my.json');
const en_SC = require('./translations/en-sc.json');
const pl = require('./translations/pl.json');
const id = require('./translations/id.json');
const vi = require('./translations/vi.json');
const ru = require('./translations/ru.json');
const th = require('./translations/th.json');
const en_FR = require('./translations/en-fr.json');


// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en,
  hi,
  ar,
  ba,
  fr,
  en_MY,
  en_SC,
  pt,
  pl,
  id,
  vi,
  ru,
  th,
  en_FR,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    ns: ['translation'],
    fallbackLng: 'en',
    resources,
    debug: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'lng',
    },
    keySeparator: false,
  });

export default i18n;
